// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1TWJE","head":"Table_head__28d6t","col":"Table_col__2Oqi2"};